// extracted by mini-css-extract-plugin
module.exports = {"analyst":"index_analyst__eY614","analystTabs":"index_analystTabs__cjuUj","analystList":"index_analystList___Sfkm","botTip":"index_botTip__WbViB"};